import React from 'react';

const STATUS_LABELS = {
  open: 'Open', in_progress: 'In Progress', ready_for_testing: 'Ready for Testing',
  ready_to_deploy: 'Ready to Deploy', deployed: 'Deployed', resolved: 'Resolved', closed: 'Closed'
};

/**
 * Single row in the (virtualized) admin/manager tickets table.
 * Memoized so re-renders of the parent list only re-render rows whose
 * `ticket` reference actually changed.
 */
function TicketRow({ ticket, style, onSelect }) {
  const handleClick = () => onSelect(ticket._id);
  const handleKeyDown = (e) => {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onSelect(ticket._id);
    }
  };

  return (
    <div
      className="ticket-row ticket-row-grid"
      style={style}
      onClick={handleClick}
      onKeyDown={handleKeyDown}
      role="row"
      tabIndex={0}
    >
      <div className="ticket-cell" role="cell"><span className="ticket-num">{ticket.ticketNumber}</span></div>
      <div className="ticket-cell" role="cell">{ticket.title}</div>
      <div className="ticket-cell" role="cell">{ticket.project?.name}</div>
      <div className="ticket-cell" role="cell">{ticket.client?.firstName} {ticket.client?.lastName}</div>
      <div className="ticket-cell" role="cell">
        <span className={`priority-badge priority-${ticket.priority}`}>{ticket.priority}</span>
      </div>
      <div className="ticket-cell" role="cell">
        <span className={`status-badge status-${ticket.status}`}>{STATUS_LABELS[ticket.status]}</span>
      </div>
      <div className="ticket-cell" role="cell">
        {ticket.assignedTo ? `${ticket.assignedTo.firstName} ${ticket.assignedTo.lastName}` : '—'}
      </div>
      <div className="ticket-cell" role="cell">{new Date(ticket.createdAt).toLocaleDateString()}</div>
    </div>
  );
}

export default React.memo(TicketRow);
